import type { ParamDefinition } from "@/params";

export type GraphicStrokeAlign = "inside" | "center" | "outside";

export const STROKE_ALIGN_PARAM: ParamDefinition<"strokeAlign"> = {
	key: "strokeAlign",
	label: "Выравнивание обводки",
	type: "select",
	default: "center",
	group: "stroke",
	options: [
		{ value: "inside", label: "Внутри" },
		{ value: "center", label: "По центру" },
		{ value: "outside", label: "Снаружи" },
	],
};
